
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block border-2 border-[#1A2B3C] px-4 py-1.5 rounded-full text-[13px] font-semibold text-[#1A2B3C] mb-6">
              Since 2018
            </div>
            
            <h2 className="font-['Playfair_Display',serif] text-[48px] font-bold text-[#1A2B3C] leading-tight mb-8">
              Your Trusted Partner<br />
              <span className="text-gray-500">in US 🇺🇸 & UK 🇬🇧</span><br />
              Business Growth
            </h2>
            
            <p className="text-[16px] text-gray-600 leading-[1.8] mb-6">
              Business Contracting Hub specializes in guiding small business owners, entrepreneurs, and startups through the complex landscape of government contracting, business formation, and compliance. With deep expertise in both US and UK markets, we simplify processes that can otherwise be overwhelming.
            </p>
            
            <p className="text-[16px] text-gray-600 leading-[1.8] mb-8">
              From SAM.gov registration to tax strategy, HACCP plans to capability statements, our comprehensive services ensure you have everything needed to compete for lucrative government contracts and grow your business with confidence.
            </p>
            
            <a href="#contact" className="inline-flex items-center gap-2 text-[15px] font-semibold text-[#1A2B3C] border-b-2 border-[#1A2B3C] pb-1 hover:text-[#D4AF37] hover:border-[#D4AF37] transition-colors cursor-pointer">
              Meet Our Team <i className="ri-arrow-right-line"></i>
            </a>
          </div>
          
          <div className="relative">
            <div className="absolute -top-8 -left-8 grid grid-cols-2 gap-8 z-10">
              <div className="bg-white p-6 rounded-xl shadow-lg">
                <div className="text-[38px] font-bold text-[#1A2B3C] leading-none">500+</div>
                <div className="text-[13px] text-gray-600 mt-2">Clients Served</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-lg">
                <div className="text-[38px] font-bold text-[#1A2B3C] leading-none">15+</div>
                <div className="text-[13px] text-gray-600 mt-2">Years Combined<br />Experience</div>
              </div>
            </div>
            
            <div className="relative mt-24 ml-8">
              <div className="absolute top-0 left-0 w-[280px] h-[280px] rounded-2xl overflow-hidden border-8 border-white shadow-xl z-20">
                <img 
                  src="https://public.readdy.ai/ai/img_res/3ef5115cfbb9abd9dd8fe62ba3ce8478.jpg" 
                  alt="Team Collaboration" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
              
              <div className="absolute top-32 left-48 w-[380px] h-[420px] rounded-2xl overflow-hidden border-8 border-white shadow-xl">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20business%20consultant%20working%20with%20entrepreneur%20client%20in%20elegant%20modern%20office%20setting%2C%20discussing%20business%20strategy%20and%20government%20contracting%20documents%2C%20sophisticated%20corporate%20environment%20with%20large%20windows%20and%20natural%20light%2C%20executive%20desk%20with%20laptop%20and%20official%20papers%2C%20professional%20photography%20showcasing%20expertise%20and%20trust%20with%20warm%20neutral%20color%20palette&width=760&height=840&seq=professional-office-about&orientation=portrait" 
                  alt="Professional Office" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
